module.exports = __webpack_public_path__ + "static/media/2.6.696e72f6.png";